// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-panel-sepa-info></molecule-panel-sepa-info> </div> </div> ";
// Exports
module.exports = code;